<template>
  <ul class="grid grid-cols-4 gap-2">
    <li
      v-for="attribute in filter.attributes"
      :id="`filter-number-${filter.key}-${attribute.key}`"
      :key="attribute.key"
    >
      <UiChip
        :id="`filter-number-${filter.key}-${attribute.key}`"
        type="text"
        size="sm"
        :value="attribute.label ?? '-'"
        @update:model-value="() => updateValue(filter.key, attribute.key)"
      />
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { FilterProps } from '~/components/ProductList/Filters/types';

defineProps<FilterProps<string[], string>>();
</script>
